// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__Lzs-q","tab":"Tabs_tab__1g7de","tabActive":"Tabs_tabActive__3gRt6"};